import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Camada_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 247 41",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#65a36f;}.cls-2{fill:#fff;}" }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M53.06,33.28V11.25c0-2.54,1.86-4.02,3.94-4.02,1.67,0,3,.61,3.83,2.01l10.08,17.29V7.76h5.23V29.79c0,2.54-1.86,3.98-3.87,3.98-1.63,0-3.03-.57-3.87-1.97l-10.08-17.4v18.88h-5.27Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M80.37,23.72c0-5.42,3.94-9.9,9.74-9.9s9.4,4.4,9.4,9.52v1.59h-13.95c.38,2.5,2.31,4.17,5.01,4.17,2.05,0,3.75-.99,4.63-2.73l4.13,2.09c-1.63,3.37-4.74,5.31-8.72,5.31-5.84,0-10.24-4.06-10.24-10.05Zm13.8-1.78c-.23-1.93-1.82-3.41-4.09-3.41s-3.91,1.52-4.28,3.41h8.38Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M102.32,23.84c0-5.42,4.44-9.9,10.16-9.9s10.2,4.51,10.2,9.9-4.44,9.93-10.2,9.93-10.16-4.47-10.16-9.93Zm14.98,.04c0-2.65-2.05-4.85-4.82-4.85s-4.78,2.2-4.78,4.85,2.01,4.85,4.78,4.85,4.82-2.2,4.82-4.85Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M125.3,28.39l2.05-1.02c1.1,2.5,3.6,3.9,6.86,3.9,3.49,0,6.14-1.78,6.14-4.89,0-3.37-3.03-4.02-6.37-4.7-3.83-.83-8.19-1.97-8.19-7.01,0-3.98,3.68-6.98,8.07-6.98,3.64,0,6.9,1.74,8.3,5.08l-2.01,1.06c-1.14-2.46-3.37-3.83-6.37-3.83s-5.57,1.93-5.57,4.59c0,3.34,3.11,4.02,6.45,4.74,3.83,.83,8.11,1.97,8.11,7.05,0,4.32-3.72,7.2-8.57,7.2-4.02,0-7.51-1.86-8.91-5.19Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M146.4,24.06c0-5.31,4.29-9.59,9.37-9.59,3.26,0,6.22,1.44,7.92,4.55l-1.97,1.14c-1.33-2.35-3.49-3.45-5.95-3.45-3.79,0-7.01,3.34-7.01,7.36s3.22,7.36,7.01,7.36c2.47,0,4.63-1.1,5.95-3.41l1.97,1.1c-1.71,3.11-4.66,4.55-7.92,4.55-5.08,.04-9.37-4.28-9.37-9.59Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M166.33,24.03c0-5.23,4.13-9.56,9.63-9.56s9.67,4.17,9.67,9.56v9.25h-2.24v-4.28c-1.4,2.77-4.25,4.66-7.73,4.66-5.31,0-9.33-4.32-9.33-9.63Zm16.95,.04c0-4.02-3.22-7.36-7.32-7.36s-7.28,3.34-7.28,7.36,3.22,7.36,7.28,7.36,7.32-3.34,7.32-7.36Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M193.5,24.06v9.21h-2.35v-9.4c0-5.31,3.22-9.4,8.76-9.4s8.95,4.06,8.95,9.37v9.44h-2.35v-9.18c0-3.94-2.31-7.39-6.6-7.39s-6.41,3.45-6.41,7.36Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M214.47,20.65V5.84h4.71c3.98,0,6.57,1.79,6.57,5.24s-2.63,5.31-6.46,5.31h-2.56v4.27h-2.26Zm2.26-12.74v6.37h2.52c2.43,0,4.18-.95,4.18-3.21s-1.68-3.16-4.18-3.16h-2.52Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M227.71,20.65v-6.46c0-2.63,1.5-4.6,4.33-4.6,.68,0,1.39,.13,1.95,.4v2.17c-.53-.31-1.15-.46-1.75-.46-1.46,0-2.34,.99-2.34,2.59v6.37h-2.19Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-2",
				d: "M234.9,15.21c0-3.12,2.54-5.66,5.79-5.66s5.75,2.56,5.75,5.66-2.5,5.7-5.75,5.7-5.79-2.56-5.79-5.7Zm9.35,.02c0-1.99-1.55-3.63-3.56-3.63s-3.6,1.64-3.6,3.63,1.57,3.6,3.6,3.6,3.56-1.64,3.56-3.6Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M35.88,0H5.13C3.71,0,2.43,.57,1.5,1.5c-.93,.93-1.5,2.21-1.5,3.62V41H35.88c2.83,0,5.12-2.29,5.12-5.13V0h-5.12Z"
		}), /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M27.68,8.2h-2.05c-.57,0-1.02,.46-1.02,1.03s.46,1.03,1.02,1.03h2.05c1.7,0,3.07,1.38,3.07,3.08v2.05c0,.57,.46,1.02,1.03,1.02s1.03-.46,1.03-1.02v-2.05c0-2.83-2.29-5.13-5.13-5.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M9.23,16.4c.57,0,1.02-.46,1.02-1.02v-2.05c0-1.7,1.38-3.08,3.07-3.08h2.05c.57,0,1.03-.46,1.03-1.03s-.46-1.03-1.03-1.03h-2.05c-2.83,0-5.12,2.29-5.12,5.13v2.05c0,.57,.46,1.02,1.03,1.02Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M31.78,24.6c-.57,0-1.03,.46-1.03,1.03v2.05c0,1.7-1.38,3.08-3.07,3.08h-2.05c-.57,0-1.02,.46-1.02,1.03s.46,1.03,1.02,1.03h2.05c2.83,0,5.13-2.29,5.13-5.13v-2.05c0-.57-.46-1.03-1.03-1.03Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M15.38,30.75h-2.05c-1.7,0-3.07-1.38-3.07-3.08v-2.05c0-.57-.46-1.03-1.02-1.03s-1.03,.46-1.03,1.03v2.05c0,2.83,2.29,5.13,5.12,5.13h2.05c.57,0,1.03-.46,1.03-1.03s-.46-1.03-1.03-1.03Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M31.78,19.47h-4.1v-7.17H13.32v7.17h-4.1c-.57,0-1.03,.46-1.03,1.03s.46,1.03,1.03,1.03h4.1v7.18h14.35v-7.18h4.1c.57,0,1.03-.46,1.03-1.03s-.46-1.03-1.03-1.03ZM14.35,13.32h12.3v6.15H14.35v-6.15Zm12.3,14.35H14.35v-6.15h12.3v6.15Z"
			})
		] })] })
	]
});
export default SvgLogo;
